import React from 'react';
import './herobottomtxt.css';

function Herobottomtxt() {
  return (
    <div className='herobottomtxt'>
      <p>Approximately <span className='percent'>93 percent of U.S. consumers</span> search for local businesses online and about <span className='percent'>88 percent of SEO local mobile searches</span> result in a store visit or phone call within 24 hours. Ramp up your local search engine optimization efforts and connect your brand with high-intent customers in your area.</p>
      <p>Thrive Internet Marketing Agency offers conversion-driven local SEO services to ensure your business ranks high in SEO local search queries and achieves revenue growth.</p>
    </div>
  );
}

export default Herobottomtxt;
